import {getOuterWallPoints} from "../../utils/wallAnalyzer";
import {t} from "../../../i18n";

export class Floor {
    constructor(includeOutside) {
        this.includeOutside = includeOutside;
        this.floorPoints = getOuterWallPoints(false, this.includeOutside);

        if (this.floorPoints.length < 4) {
            throw new Error(t("floor_no_outer_wall"));
        }
    }
}

export function checkForFloorCreation(){
    let floorPoints = getOuterWallPoints(false, false);
    return floorPoints.length >= 4;
}
